import React from 'react';
import { DndProvider } from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import {createRoot} from 'react-dom/client';
import { Provider } from 'react-redux';
// import 'jquery/jquery.min.js'
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import './scrollbars.css';
import * as serviceWorker from './serviceWorker';
import store from './store';


const root=createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// if (module.hot) {
//   module.hot.accept('./App', () => {
//     root.render(
//       <Provider store={store}>
//         <DndProvider backend={HTML5Backend}>
//           <App />
//         </DndProvider>
//       </Provider>,
//       document.getElementById('root'),
//     );
//   });
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
